export default __webpack_public_path__ + "static/media/TER1.516d1823.jpg";